import { useMeetContext } from '../../../../features/Meet';
import { useThemeContext } from '../../../../features/Theme/providers/ThemeContextProvider';
import { useTranslationsContext } from '../../../../features/Translations/providers/TranslationsContextProvider';
import { Message } from '../../../components/Messages/Message';
import SessionIcon from '../../../assets/icons/session.svg?react';
import { useCallback, useState } from 'react';
import { Column } from '../../../components/Column/Column';
import { Row } from '../../../components/Row/Row';
import { Button } from '../../../components/Button/Button';
import { Modal } from '../../../components/Modal/Modal';
import { SheetModalHeader } from '../../../components/SheetModal/SheetModalHeader';
import { SheetModal } from '../../../components/SheetModal/SheetModal';
import { useIsMobile } from '../../../hooks/useIsMobile';

export interface HangUpModalProps {
	show?: boolean;
	onClose?: () => void;
}

export function HangUpModal({ show = false, onClose }: Readonly<HangUpModalProps>) {
	const { t } = useTranslationsContext();
	const theme = useThemeContext();
	const isMobile = useIsMobile();
	const { features, hangUpAndFinish } = useMeetContext();
	const [isProcessing, setIsProcessing] = useState(false);

	const handleOnClick = useCallback(() => {
		setIsProcessing(true);
		try {
			if (onClose) onClose();
			setTimeout(() => {
				hangUpAndFinish();
			}, 100);
		} catch(error) {
			setIsProcessing(false);
		}
	}, []);

	const content = () => {
		return (
			<Column $spaceBetween $fillHeight $gap={20}>
				{features?.minDurationWarning && (
					<Message message={t('hang_up.warning')} type={'warning'}></Message>
				)}
				<div dangerouslySetInnerHTML={{ __html: t('hang_up.message') }}></div>
				<Row $hcenter $fillSpace $gap={20}>
					<Button
						$color={'primary'}
						$block
						$loading={isProcessing}
						disabled={isProcessing}
						onClick={handleOnClick}
					>
						{t('hang_up.finish')}
					</Button>
				</Row>
			</Column>
		);
	};

	return (
		<>
			{isMobile && (
				<SheetModal
					data-test="hang-up-modal-mobile"
					isOpen={show}
					header={
						<SheetModalHeader
							prepend={
								<SessionIcon fill={theme.colors.brand.primary[300]} width={25} height={25} />
							}
							title={t('hang_up.title')}
						/>
					}
					onClose={onClose}
				>
					{content()}
				</SheetModal>
			)}
			{!isMobile && (
				<Modal
					data-test="hang-up-modal-desktop"
					show={show}
					onClose={onClose}
					title={t('hang_up.title')}
					$fitToChildren
					prepend={
						<SessionIcon
							fill={theme.colors.brand.primary[300]}
							width={25}
							height={25}
						></SessionIcon>
					}
				>
					{content()}
				</Modal>
			)}
		</>
	);
}
